import { combineEpics, ofType } from 'redux-observable';
import { concatMap } from 'rxjs/operators';
import { initiateEmployeeOnBoardingPrivateMethod } from '../../generated/api/uiApiMethods.js';
import {
  TypeKeys,
  initiateEmployeeOnBoardingFailed,
  initiateEmployeeOnBoardingFulfilled,
  initiateEmployeeOnBoardingResendFailed,
} from '../actions/index.js';
import { callUiApi, prepareUiApiRequest } from '../common/uiApiUtils.js';
import { actionToActionState, getMdmIdHeaderFromUrlParams } from './epicUtils.js';
import type { ActionAndState, EpicDependencies } from './epicUtils.js';
import type { ActionTypes, InitiateEmployeeOnBoardingAction } from '../actions/index.js';
import type { State } from '../common/store.js';
import type { Action } from 'redux';
import type { ActionsObservable, Epic, StateObservable } from 'redux-observable';

export const initiateEmployeeOnboarding: Epic<ActionTypes, Action, State, EpicDependencies> = (
  action$: ActionsObservable<ActionTypes>,
  state$: StateObservable<State>,
  epicDependencies: EpicDependencies
) =>
  prepareUiApiRequest(
    action$.pipe(ofType(TypeKeys.INITIATE_EMPLOYEE_ONBOARDING)),
    (action: InitiateEmployeeOnBoardingAction) => actionToActionState(action, state$, 'authenticated')
  ).pipe(
    concatMap((actionAndState: ActionAndState) => {
      const initiateEmployeeOnboardingAction = actionAndState.action as InitiateEmployeeOnBoardingAction;
      const failureAction = initiateEmployeeOnboardingAction.resend
        ? initiateEmployeeOnBoardingResendFailed
        : initiateEmployeeOnBoardingFailed;
      return callUiApi({
        epicDependencies,
        state$,
        headers: getMdmIdHeaderFromUrlParams(),
        method: initiateEmployeeOnBoardingPrivateMethod(),
        payload: initiateEmployeeOnboardingAction.payload,
        successAction: initiateEmployeeOnBoardingFulfilled,
        failureAction,
      });
    })
  );

export const employeeOnboardingEpic: Epic<ActionTypes, Action, State, EpicDependencies> =
  combineEpics(initiateEmployeeOnboarding);
